import * as contentful from 'contentful';
import {scrubVideoData, scrubArticleData} from './data';

const client = contentful.createClient({
    space       : process.env.REACT_APP_SPACE_TOKEN,
    accessToken : process.env.REACT_APP_ACCESS_TOKEN
});

const getContentForLtm = ltm => Promise.all([
    client.getEntries({content_type: `video`, "fields.ltm": ltm}),
    client.getEntries({content_type: `article`, "fields.ltm": ltm})
]).then(([videos, articles]) => {
    let content               = [];
    const cleanedVideosData   = scrubVideoData(videos.items);
    const cleanedArticlesData = scrubArticleData(articles.items);

    Object.keys(cleanedVideosData).forEach(key => {
        content.push(cleanedVideosData[key]);
    });
    Object.keys(cleanedArticlesData).forEach(key => {
        content.push(cleanedArticlesData[key]);
    });

    return content;
});

const getBodyCopyForLtm = ltm => client.getEntries({content_type: `resultsPage`, "fields.ltm": ltm}).then(copy => copy.items[0].fields);

export {client, getContentForLtm, getBodyCopyForLtm};
